/* eslint-disable class-methods-use-this */
import React from 'react';
import framework from 'utils/framework';
const { wrapComponent } = framework;
import BaseClass from 'components/BaseClass';
import TargetedLandingPromotion from 'components/Content/TargetedLandingPromotion';

class TargetedLandingPage extends BaseClass {
    render() {
        return <TargetedLandingPromotion />;
    }
}

export default wrapComponent(TargetedLandingPage, 'TargetedLandingPage', true);
